import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateTestimonial } from '../api/api';

export const useCreateTestimonial = ({ onSuccessCallback, onErrorCallback }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data }) => {
      const res = await CreateTestimonial(data);
      if (res.error) throw new Error(res.error);
      return res.data;
    },
    onSuccess: (newData) => {
      // queryClient.setQueryData(['testimonial'], (oldData) => {
      //   if (!oldData || !Array.isArray(oldData.data)) {
      //     // First entry or unexpected shape
      //     return {
      //       data: [newData],
      //       pageCount: 1,
      //     };
      //   }

      //   // Merge new testimonial into existing list
      //   return {
      //     ...oldData,
      //     data: [...oldData.data, newData],
      //   };
      // });

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (err) => {
      if (onErrorCallback) {
        onErrorCallback(err.message || 'Failed to submit');
      }
    },
  });
};

